var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDafuku(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400.28 72.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#51489d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,14.41,44.63,0H0V72.77H44.63L59,58.36Zm-37.3,44V14.41H37.3v44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.82,0,58.54,72.75H80.27l3-12.2h17.17l3,12.2h21.72L104.85,0Zm8,46.14,5.06-20.69,5.06,20.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 128.43,
    width: 21.73,
    height: 72.77
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "178.4 14.41 206.38 14.41 206.38 0 171.07 0 156.67 14.41 156.67 72.77 178.4 72.77 178.4 43.56 206.83 43.56 206.83 29.14 178.4 29.14 178.4 14.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "248.86 58.36 234.37 58.36 234.37 0 212.65 0 212.65 58.36 227.04 72.77 270.58 72.77 270.58 0 248.86 0 248.86 58.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.69 0.08 299.19 21.58 299.19 0 277.46 0 277.46 72.77 299.19 72.77 299.19 43.51 314.4 43.51 314.4 72.77 336.13 72.77 336.13 43.51 321.73 29.1 310.99 29.1 325.67 14.41 336.13 14.41 336.13 0.07 320.69 0.07 320.69 0.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.55 0 378.55 58.36 364.07 58.36 364.07 0 342.34 0 342.34 58.36 356.73 72.77 400.28 72.77 400.28 0 378.55 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDafuku);
export default __webpack_public_path__ + "static/media/icon_dafuku.35b646dd20769eb59a0d33d29960eef4.svg";
export { ForwardRef as ReactComponent };